// Whether an analysis-list row offers the unified "U" button (roadmap R1.38).
//
// Germline, unchanged: TRACKS, appended once the read-depth and BAF tracks are
// ready. A somatic analysis never earns TRACKS (no tumour actor precomputes
// tracks yet, and an uploaded VCF has no BAM), so it gets its own entry point:
// the "Somatic" tag plus SOMATIC_UNIFIED, which the somatic export appends once
// the somatic parquet and its position-sorted copy are both uploaded. The tag is
// required so a stray SOMATIC_UNIFIED can never put a button on a germline row.
// The server, not this button, decides the mode the screen opens in.
export const SOMATIC_UNIFIED_TAG = 'SOMATIC_UNIFIED'

export const showUnifiedButton = (analysisRow) => {
  const finished = analysisRow?.finished_pipelines || []
  if (finished.includes('TRACKS')) return true
  return !!analysisRow?.tags?.includes('Somatic') && finished.includes(SOMATIC_UNIFIED_TAG)
}
